// extracted by mini-css-extract-plugin
module.exports = {"SpinnerArea":"Spinner_SpinnerArea__rGQ8V","Center":"Spinner_Center__2_V4_","Small":"Spinner_Small__2wMVe","Spinner":"Spinner_Spinner__3j-1d"};